export { default as Avatar } from './Avatar'
export { AvatarShape, AvatarSize, AvatarStyle } from './types'
export type { AvatarProps, AvatarComponentType } from './types'
